import React, { createContext, useCallback, useContext, useEffect, useMemo } from 'react';
import { useUtils } from '../../../../context/UtilsContext';

const WorkoutDataContext = createContext({
  workoutCommonUtils: null,
  loading: false,
  error: null,
  refreshWorkoutUtils: () => {},
});

export function useWorkoutData() {
  return useContext(WorkoutDataContext);
}

/**
 * Bootstrap workout common utils under /fitness/* routes.
 * Reads through UtilsContext (session cache + shared in-memory state).
 */
export function WorkoutDataProvider({ children }) {
  const {
    workoutCommonUtils,
    workoutUtilsLoading,
    workoutUtilsError,
    fetchWorkoutCommonUtils,
  } = useUtils();

  useEffect(() => {
    if (!workoutCommonUtils) {
      fetchWorkoutCommonUtils();
    }
  }, [workoutCommonUtils, fetchWorkoutCommonUtils]);

  const refreshWorkoutUtils = useCallback(async () => {
    return fetchWorkoutCommonUtils();
  }, [fetchWorkoutCommonUtils]);

  const value = useMemo(
    () => ({
      workoutCommonUtils,
      loading: workoutUtilsLoading,
      error: workoutUtilsError,
      refreshWorkoutUtils,
    }),
    [workoutCommonUtils, workoutUtilsLoading, workoutUtilsError, refreshWorkoutUtils]
  );

  return (
    <WorkoutDataContext.Provider value={value}>{children}</WorkoutDataContext.Provider>
  );
}
